import { render, staticRenderFns } from "./show.support-tickets.page.vue?vue&type=template&id=01b08170&scoped=true&"
import script from "./show.support-tickets.page.vue?vue&type=script&lang=js&"
export * from "./show.support-tickets.page.vue?vue&type=script&lang=js&"
import style0 from "./show.support-tickets.page.vue?vue&type=style&index=0&id=01b08170&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b08170",
  null
  
)

export default component.exports